import React, { useState } from 'react';
import '../../Components/Page/Page.css';
import MainContent from './MainContent';
import Footer from '../../Components/Footer/FooterSmall';
import Header2 from '../../Components/Header2/Header2';
import HorizontalScoll from '../../Components/HScroll/HScroll';
import CFOVideo from '../../Content/CFOVideo/CFOVideo';
import Rotator from '../../Components/Rotator/Rotator';
import VdoCipherComp from '../../Components/VdoCipher/VdoCipher';
import SecHeader from '../../Components/SecHeader/SecHeader';
// ReactGA.initialize("G-EYZMP7R3ZE")

// ReactGA.send({
//   hitType: "pageview",
//   page: window.location.pathname,
// })

const LandingPage1: React.FC = () => {
  const [isToggled, showVideo] = useState<boolean>(false);

  // Handler to toggle the state
  const handleToggle = () => {
    showVideo((prev: boolean) => !prev);
  };

  return (

    <div className='generalPageOverflow'>
      <Header2 />
      <Rotator/>
      <div className='pageContainer'>
        <MainContent onClick={handleToggle} />
        {isToggled && (
          <div>
          <SecHeader title="A new Generation of Engines" />
          <VdoCipherComp filename="igreviewcfo"/>
          {/* // <CFOVideo/> */}
          </div>
        )}
        <HorizontalScoll />
      </div>
      <Footer />
    </div>

  );
};

export default LandingPage1;